import React from 'react';
import { SPACE_CARD_STYLE } from '../SpacesView';
import { SpaceCard } from './SpaceCard';

const SpaceLoadingCards = () => {
  return (
    <>
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
      <SpaceCard
        style={SPACE_CARD_STYLE}
        className="flex items-center justify-center "
      />
    </>
  );
};

export default SpaceLoadingCards;
